import React from 'react';
import Aquabanner from '../../assets/aquabanner.png';



const BirdsBanner = () => {
    return (
        <div
            className="aqua-banner relative mt-[115px] lg:mt-[188px] h-[400px] bg-cover bg-center flex items-center justify-center"
            style={{ backgroundImage: `url(${Aquabanner})` }}
        >
            <nav aria-label="breadcrumb" className="text-center">
                <h1 className='text-4xl font-bold text-white'>Birds</h1>
                <ol className="list-none p-0 inline-flex text-white">
                    <li className="flex items-center">
                        <a href="/" className="hover:text-blue-400">Home</a>
                    </li>
                    <li className="flex items-center">
                        <a className="text-blue-400">
                        <i className="fas fa-arrow-right ml-2 mr-2"></i> {/* Replace with your actual Aeromark icon */}
                        </a>
                    </li>
                    <li className="flex items-center text-white">
                    <a href="/aqua" className="hover:text-blue-400">Birds</a>
                    </li>
                </ol>
            </nav>
        </div>
    );
};

export default BirdsBanner;
